import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportUnitsWithPermissionFilters, getReportUnitsWithPermissionAction } from "redux/actions/Reports/reportUnitsWithPermission/reportUnitsWithPermissionActions";
import { useSearch } from "hooks/useSearch";

export const ReportUnitsWithPermissionView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { station } = useSelector(state => state.reportUnitsWithPermission);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    dispatch(getReportUnitsWithPermissionAction({ station, isPdf }));
  }, [station]);

  return (
    <GlobalBox title="Reporte Unidades con Permiso" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportUnitsWithPermission"
        stations
        dispatchAction={setReportUnitsWithPermissionFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingUnitsWithPermission}
      />
      {isLoadingComp?.loadingUnitsWithPermission && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
